import React, { useState, useEffect } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setLoader } from '../../../../../redux/ducks/load.duck';
import * as schoolDUCK from "../../../../../redux/ducks/school.duck"
import { searchSchools } from '../../../../../app/crud/api/schools.crud';

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    color: "white",
    minHeight: '48px',
    '& input': {
      whiteSpace: 'pre-wrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '0 14px !important',
      height: 'auto !important',
      minHeight: '24px',
      maxHeight: '72px',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .MuiInputBase-inputMultiline': {
      padding: '0 14px !important',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white !important',
      fontSize: '1.1rem',
      fontWeight: '500',
      letterSpacing: '0.5px'
    }
  },
  clearIndicator: {
    color: "white"
  },
  popupIndicator: {
    color: "white"
  },
  notchedOutline: {
    borderColor: "#ffffff !important",
  },
  label: {
    color: "white !important",
    marginBottom: "8px",
    display: "block",
    fontSize: "0.875rem",
    fontWeight: 500,
    textAlign: 'center'
  },
  container: {
    marginBottom: "16px",
  },
  option: {
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '8px 14px',
  },
  paper: {
    maxWidth: '400px',
  },
  listbox: {
    maxHeight: '300px',
  }
}))

const SchoolSelector = ({ setLoad, school, setSelectedSchool }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("")
  const loading = open && options.length === 0;

  useEffect(() => {
    if (open) searchSchools(search, setOptions)
  }, [open, search])

  useEffect(() => {
    if (!open) setOptions([])
  }, [open])

  return (
    <div className={classes.container}>
      <label className={classes.label}>Select Organization</label>
      <Autocomplete
        fullWidth
        classes={{ 
          clearIndicator: classes.clearIndicator, 
          inputRoot: classes.inputRoot, 
          popupIndicator: classes.popupIndicator,
          paper: classes.paper,
          listbox: classes.listbox
        }}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={options}
        loading={loading}
        value={school}
        inputValue={search}
        onChange={(e, value) => {setSelectedSchool(value);setLoad(true);}}
        onInputChange={(e, newInputValue) => setSearch(newInputValue)}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option && option.name ? option.name : ""}
        renderOption={(option) => (
          <Typography className={classes.option}>
            {option.name}
          </Typography>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            multiline
            variant="outlined"
            placeholder="Search for an organization..."
            InputProps={{
              ...params.InputProps,
              classes: {
                notchedOutline: classes.notchedOutline,
              },
              endAdornment: (
                <>
                  {loading && <CircularProgress size={20} />}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
      />
    </div>
  );
}

const mapStateToProps = store => {
  return ({
    school: store.school.selected_school,
  })
}

const mapDispatchToProps = dispatch => ({
  setLoad: bindActionCreators(setLoader, dispatch),
  setSelectedSchool: bindActionCreators(schoolDUCK.actions.setSelectedSchool, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SchoolSelector)
